import {
    Alert,
    AlertDescription,
    AlertIcon,
    AlertTitle,
    Box,
    Button,
    CloseButton,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Input,
    Link,
    Text,
} from "@chakra-ui/react";

import { Link as ReactRouterLink, useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from "react";
import { Auth } from "../../lib/Auth";

export default function ResetPasswordComponent(
  {
    isAlertVisible,
    alertMessage,
    alertStatus,
    showAlert,
    hideAlert
  }
) {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (email && !isEmailValid(email)) {
            showAlert("Please enter a valid email address.");
        } else {
            hideAlert();
        }
    }, [email]);

    const isEmailValid = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const processReset = (response) => {
        const { msg } = response;
        if (response.type === "ok") {
            showAlert(msg, "success");
            navigate("/login");
        } else {
            showAlert(msg || "Password reset failed");
        }
    };

    const submitReset = async (event) => {
        event.preventDefault();
        try {
            const response = await Auth.requestPasswordReset(email);
            processReset(response);
        } catch (error) {
            showAlert(`Error during password reset: ${error.message}`);
        }
    };

    return (
        <Flex minH="100vh" justifyContent="center" alignItems="center">
            <Box
                p={8}
                minWidth={{ base: "90%", sm: "400px", md: "500px", lg: "500px" }}
                maxWidth={{ base: "90%", sm: "540px", md: "600px", lg: "800px" }}
                borderWidth={1}
                borderRadius={8}
                boxShadow="lg"
            >
                {isAlertVisible && (
                    <Alert status={alertStatus}>
                        <AlertIcon />
                        <Box flex="1">
                            <AlertTitle>
                                <Text casing="capitalize">{alertStatus}</Text>
                            </AlertTitle>
                            <AlertDescription display="block">
                                {alertMessage}
                            </AlertDescription>
                        </Box>
                        {alertStatus === "error" && (
                            <CloseButton
                                position="absolute"
                                right="8px"
                                top="8px"
                                onClick={() => hideAlert()}
                            />
                        )}
                    </Alert>
                )}
                <Box textAlign="center">
                    <Heading>Reset Password</Heading>
                </Box>
                <Box my={4} textAlign="left">
                    <form onSubmit={submitReset}>
                        <FormControl isRequired>
                            <FormLabel>Email</FormLabel>
                            <Input
                                type="text"
                                placeholder="Enter your email"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </FormControl>
                        <Button
                            width="full"
                            mt={4} type="submit"
                            colorScheme="teal"
                        >
                            Send Password Reset Link
                        </Button>
                    </form>
                </Box>
                <Box my={1} textAlign="right">
                    <Link as={ReactRouterLink} onClick={() => hideAlert()} to="/login">
                        Back to Sign in
                    </Link>
                </Box>
            </Box>
        </Flex>
    );
}
